import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import HomeIcon from "@material-ui/icons/Home";
import BusinessIcon from "@material-ui/icons/Business";
import EventNoteIcon from "@material-ui/icons/EventNote";
import AccountBoxIcon from "@material-ui/icons/AccountBox";
import InboxIcon from "@material-ui/icons/MoveToInbox";
import BuildIcon from "@material-ui/icons/Build";
import ExtensionIcon from "@material-ui/icons/Extension";
import AddShoppingCartIcon from "@material-ui/icons/AddShoppingCart";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import AccessibilityNewIcon from "@material-ui/icons/AccessibilityNew";
import BusinessCenterIcon from "@material-ui/icons/BusinessCenter";
import FeaturedPlayListIcon from "@material-ui/icons/FeaturedPlayList";
// import Collapse from "@material-ui/core/Collapse";
// import ChromeReaderModeRoundedIcon from "@material-ui/icons/ChromeReaderModeRounded";
import AssignmentIcon from '@material-ui/icons/Assignment';
import DirectionsRunIcon from '@material-ui/icons/DirectionsRun';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import MoneyOffIcon from '@material-ui/icons/MoneyOff';
import LocalAtmIcon from '@material-ui/icons/LocalAtm';
import NotificationImportantIcon from '@material-ui/icons/NotificationImportant';
import ReceiptIcon from '@material-ui/icons/Receipt';
import AssessmentIcon from '@material-ui/icons/Assessment';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import ContactMailIcon from '@material-ui/icons/ContactMail';
import HomeWorkIcon from '@material-ui/icons/HomeWork';
import CallReceivedIcon from '@material-ui/icons/CallReceived';
import CallMadeIcon from '@material-ui/icons/CallMade';
import DescriptionIcon from '@material-ui/icons/Description';
import TimelineIcon from '@material-ui/icons/Timeline';
import EqualizerIcon from '@material-ui/icons/Equalizer';
import LanguageIcon from '@material-ui/icons/Language';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
//import ProductionQuantityLimitsIcon from '@material-ui/icons/ProductionQuantityLimits';
import GroupIcon from '@material-ui/icons/Group';

const useStyles = makeStyles((theme) => ({
  small: {
    fontSize: 20,
    color: theme.palette.secondary.icons,
  },
  primarycolored: {
    color: theme.palette.primary.icons,
  },
  secondarycolored: {
    color: theme.palette.secondary.icons,
  },
}));
const IconList = ({ name }) => {
  const classes = useStyles();
  if (name === "Home") return <HomeIcon className={classes.secondarycolored} />;
  else if (name === "Business")
    return <BusinessIcon className={classes.primarycolored} />;
  else if (name === "EventNote")
    return <EventNoteIcon className={classes.primarycolored} />;
  else if (name === "AccountBox")
    return <AccountBoxIcon className={classes.primarycolored} />;
  else if (name === "MoveToInbox")
    return <InboxIcon className={classes.primarycolored} />;
  else if (name === "Build")
    return <BuildIcon className={classes.secondarycolored} />;
  else if (name === "Extension")
    return <ExtensionIcon className={classes.primarycolored} />;
  else if (name === "AddShoppingCart")
    return <AddShoppingCartIcon className={classes.secondarycolored} />;
  else if (name === "ExpandLess")
    return <ExpandLess className={classes.primarycolored} />;
  else if (name === "ExpandMore")
    return <ExpandMore className={classes.primarycolored} />;
  else if (name === "AccessibilityNewIcon")
    return <AccessibilityNewIcon className={classes.primarycolored} />;
  else if (name === "BusinessCenterIcon")
    return <BusinessCenterIcon className={classes.primarycolored} />;
  else if (name === "FeaturedPlayListIcon")
    return <FeaturedPlayListIcon className={classes.secondarycolored} />;
  else if (name === "AccessibilityNewIconSmall")
    return <AccessibilityNewIcon className={classes.small} />;
  else if (name === "BusinessCenterIconSmall")
    return <BusinessCenterIcon className={classes.small} />;
  else if (name === "FeaturedPlayListIconSmall")
    return <FeaturedPlayListIcon className={classes.small} />;
  else if (name === "HomeSmall")
    return <HomeIcon className={classes.small} />;
  else if (name === "BusinessSmall")
    return <BusinessIcon className={classes.small} />;
  else if (name === "EventNoteSmall")
    return <EventNoteIcon className={classes.small} />;
  else if (name === "AccountBoxSmall")
    return <AccountBoxIcon className={classes.small} />;
  else if (name === "SalesOrderIcon")
    return <AssignmentIcon className={classes.small} />;
  else if (name === "ActivityIcon")
    return <DirectionsRunIcon className={classes.small} />;
  else if (name === "QuotationAnalysisIcon")
    return <AttachMoneyIcon className={classes.small} />;
  else if (name === "QuotationLostAnalysisIcon")
    return <MoneyOffIcon className={classes.small} />;
  else if (name === "QuotationIcon")
    return <LocalAtmIcon className={classes.small} />;
  else if (name === "CustomerCompaintIcon")
    return <NotificationImportantIcon className={classes.small} />;  
  else if (name === "InvoiceIcon")
    return <ReceiptIcon className={classes.small} />;  
  else if (name === "SalesAnalysisIcon")
    return <AssessmentIcon className={classes.small} />; 
  else if (name === "DeliveryIcon")
    return <LocalShippingIcon className={classes.small} />; 
  else if (name === "DispatchManagementIcon")
    return <ContactMailIcon className={classes.small} />;
  else if (name === "FGInwardToWarehouseIcon")
    return <HomeWorkIcon className={classes.small} />;
  else if (name === "StockInwardIcon")
    return <CallReceivedIcon className={classes.small} />;
  else if (name === "StockOutwardIcon")
    return <CallMadeIcon className={classes.small} />;  
  else if (name === "StockLedgerIcon")
    return <DescriptionIcon className={classes.small} />; 
  else if (name === "StockStatusIcon")
    return <TimelineIcon className={classes.small} />; 
  else if (name === "SalesTargetVsActualIcon")
    return <EqualizerIcon className={classes.small} />; 
   else if (name === "CountryIcon")
    return <LanguageIcon className={classes.small} />; 
  else if (name === "AccountTreeIcon")
    return <AccountTreeIcon className={classes.small} />; 
  else if (name === "GroupWorkIcon")
    return <GroupIcon className={classes.small} />; 
};

export default IconList;
